import { useNavigate, useLocation } from 'react-router-dom'
import { Home, User } from 'lucide-react'
import { useTheme } from '../lib/theme-provider'

export default function BottomNav() {
  const navigate = useNavigate()
  const location = useLocation()
  const { theme } = useTheme()

  // 隐藏导航栏的路径
  const hidePaths = ['/login']
  if (hidePaths.includes(location.pathname)) {
    return null
  }

  const navItems = [
    { path: '/', icon: Home, label: '首页' },
    { path: '/profile', icon: User, label: '我的' },
  ]

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/'
    }
    return location.pathname.startsWith(path)
  }

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 w-full"
      style={{ 
        backgroundColor: theme.colors['bg-secondary'],
        borderTop: `1px solid ${theme.colors['border-secondary'] || '#5A4BFF'}35`,
        zIndex: 1000,
      }}
    >
      <div className="flex items-center justify-around py-1.5 pb-2">
        {navItems.map((item) => {
          const Icon = item.icon
          const active = isActive(item.path)
          
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className="flex flex-col items-center justify-center w-full py-1 transition-all"
            >
              <div 
                className={`w-9 h-9 rounded-lg flex items-center justify-center transition-all ${
                  active ? 'scale-110' : 'opacity-70'
                }`}
                style={{
                  backgroundColor: active ? `${theme.colors['accent-gold']}20` : 'transparent',
                }}
              >
                <Icon 
                  className="w-5 h-5" 
                  style={{ 
                    color: active ? theme.colors['accent-gold'] : theme.colors['text-secondary'] 
                  }} 
                />
              </div>
              <span 
                className="text-[11px] mt-0.5 font-medium"
                style={{ 
                  color: active ? theme.colors['accent-gold'] : theme.colors['text-muted'] 
                }}
              >
                {item.label}
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
